/**
 * RH (Recursos Humanos) Module Routes
 */

import { lazy } from "react";
import { ModuleRoutes } from "../types";

// Lazy load components
const Colaboradores = lazy(() => import("@/pages/rh/Colaboradores"));
const CadastroColaborador = lazy(() => import("@/pages/rh/CadastroColaborador"));
const Organograma = lazy(() => import("@/pages/rh/organograma"));
const EditarColaborador = lazy(() => import("@/pages/rh/EditarColaborador"));
const MigracaoSetorUnidade = lazy(() => import("@/pages/rh/MigracaoSetorUnidade"));
const DesligamentoColaborador = lazy(() => import("@/pages/rh/DesligamentoColaborador"));
const DashboardSetores = lazy(() => import("@/pages/rh/DashboardSetores"));
const LogsMovimentacao = lazy(() => import("@/pages/rh/LogsMovimentacao"));
const CadastroCategoriaOrganograma = lazy(() => import("@/pages/rh/CadastroCategoriaOrganograma"));
const EditorEstruturaOrganograma = lazy(() => import("@/pages/rh/EditorEstruturaOrganograma"));
const ControleUnidades = lazy(() => import("@/pages/rh/ControleUnidades"));
const CadastroSetores = lazy(() => import("@/pages/rh/CadastroSetores"));
const VisualizacaoOrganograma = lazy(() => import("@/pages/rh/VisualizacaoOrganograma"));
const AuditoriaOrganograma = lazy(() => import("@/pages/rh/AuditoriaOrganograma"));
const ConfiguracoesRH = lazy(() => import("@/pages/rh/ConfiguracoesRH"));

export const rhRoutes: ModuleRoutes = {
  moduleId: "rh",
  basePath: "/rh",
  routes: [
    {
      path: "/rh/colaboradores",
      element: <Colaboradores />,
      permission: { resource: "rh", action: "colaboradores_read" },
    },
    {
      path: "/rh/cadastro-colaborador",
      element: <CadastroColaborador />,
      permission: { resource: "rh", action: "colaboradores_create" },
    },
    {
      path: "/rh/organograma",
      element: <Organograma />,
      permission: { resource: "rh", action: "organograma_view" },
    },
    {
      path: "/rh/editar-colaborador/:id",
      element: <EditarColaborador />,
      permission: { resource: "rh", action: "colaboradores_update" },
    },
    {
      path: "/rh/migracao-setor-unidade",
      element: <MigracaoSetorUnidade />,
      permission: { resource: "rh", action: "migracao_execute" },
    },
    {
      path: "/rh/desligamento",
      element: <DesligamentoColaborador />,
      permission: { resource: "rh", action: "desligamento_execute" },
    },
    {
      path: "/rh/dashboard-setores",
      element: <DashboardSetores />,
      permission: { resource: "rh", action: "dashboard" },
    },
    {
      path: "/rh/logs-movimentacao",
      element: <LogsMovimentacao />,
      permission: { resource: "rh", action: "auditoria_view" },
    },
    {
      path: "/rh/cadastro-categoria-organograma",
      element: <CadastroCategoriaOrganograma />,
      permission: { resource: "rh", action: "setores_create" },
    },
    {
      path: "/rh/editor-estrutura-organograma",
      element: <EditorEstruturaOrganograma />,
      permission: { resource: "rh", action: "organograma_edit" },
    },
    {
      path: "/rh/controle-unidades",
      element: <ControleUnidades />,
      permission: { resource: "rh", action: "setores_read" },
    },
    {
      path: "/rh/cadastro-setores",
      element: <CadastroSetores />,
      permission: { resource: "rh", action: "setores_create" },
    },
    {
      path: "/rh/visualizacao-organograma",
      element: <VisualizacaoOrganograma />,
      permission: { resource: "rh", action: "organograma_view" },
    },
    {
      path: "/rh/auditoria-organograma",
      element: <AuditoriaOrganograma />,
      permission: { resource: "rh", action: "auditoria_view" },
    },
    {
      // A trava da troca da própria foto (28/09/2026). `rh:manage` é o MESMO
      // par que o backend exige em `PUT /rh/configuracoes` — uma permissão
      // diferente aqui abriria a tela para quem o backend recusaria ao salvar.
      path: "/rh/configuracoes",
      element: <ConfiguracoesRH />,
      permission: { resource: "rh", action: "manage" },
    },
  ],
};
